import React from 'react';
import PropTypes from 'prop-types';

function L1Button({ active, activeColor, color }) {
  return (
    <path
      d="M178.761 100.232C179.762 100.203 180.798 100.191 181.864 100.192C185.062 100.195 188.533 100.322 192.159 100.535C196.994 100.818 202.105 101.253 205.681 101.688C209.258 102.124 211.302 102.559 212.484 103.051C213.667 103.543 213.988 104.093 214.282 105.096C214.575 106.099 214.839 107.555 215.217 109.968C215.575 112.248 216.025 115.347 216.21 117.537C213.626 117.346 210.345 117.448 204.236 118.183C197.353 119.012 186.89 120.641 172.883 123.081C158.876 125.521 141.329 128.769 129.076 131.388C123.383 132.605 118.874 133.679 115.259 134.61C115.684 131.425 116.104 128.336 116.447 126.288C116.949 123.299 117.289 122.486 118.216 121.512C119.142 120.538 120.658 119.401 124.451 117.075C128.243 114.748 134.32 111.226 141.937 108.36C149.553 105.493 158.712 103.279 165.014 101.992C171.315 100.706 174.76 100.346 178.761 100.232Z"
      fill={active ? activeColor : color}
    />
  );
}

L1Button.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

L1Button.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#1A1A21',
};

export default L1Button;
